import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM8 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM12 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM16 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
      fill: "#0F0F0F"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 2a1 1 0 0 1 2 0v1h8V2a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1V2Zm10 3v1a1 1 0 1 0 2 0V5h1a1 1 0 0 1 1 1v3H4V6a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V5h8ZM4 11v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9H4Z",
      fill: "#0F0F0F"
    }, null, -1)
  ]))]))
}
export default { render };